























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import i18nService from '@/services/i18n';
import { Ax } from '@/utils';
import { Overlay } from '../components';
import { Comp } from '../types';


/** Кандидат на импорт из Favorit (метаданные полученного файла) */
interface FavoriteMetaDataCandidate {
    id: number;
    docNumber: string;
    docDate: string;
    creationMoment: string;
    codeGu: string;
}

/** Строка таблицы кандидатов */
interface IRow {
    id: string;
    data: FavoriteMetaDataCandidate;
    _rowVariant: 'primary' | null;
}

const modelChangeEvent = 'input';
const importedEvent = 'imported';

const translates = {
    get title(): string {
        return i18nService.choose(
            'Импорт из Favorit',
            'Favorit жүйесінен импорттау',
            'Import from Favorit',
        );
    },
    get import(): string {
        return i18nService.choose(
            'Импортировать',
            'Импорттау',
            'Import',
        );
    },
    get cancel(): string {
        return i18nService.choose(
            'Отменить',
            'Бас тарту',
            'Cancel',
        );
    },
    get empty(): string {
        return i18nService.choose(
            'Нет доступных для импорта организаций',
            'Импорттауға қолжетімді ұйымдар жоқ',
            'There are no organizations available for import',
        );
    },
    get noOrgSelected(): string {
        return i18nService.choose(
            'Сначала выберите организацию на странице',
            'Алдымен парақшада ұйымды таңдаңыз',
            'Select an organization on the page first',
        );
    },
    fields: {
        get year(): string {
            return i18nService.choose(
                'Год',
                'Жыл',
                'Year',
            );
        },
        get title(): string {
            return i18nService.choose(
                'Наименование версии',
                'Нұсқа атауы',
                'Version title',
            );
        },
    },
    columns: {
        get id(): string {
            return i18nService.choose(
                'ID',
                'ID',
                'ID',
            );
        },
        get docNumber(): string {
            return i18nService.choose(
                'Номер тарификации из Favorit',
                'Құжат нөмірі',
                'Document number',
            );
        },
        get docDate(): string {
            return i18nService.choose(
                'Дата тарификации',
                'Құжат күні',
                'Document date',
            );
        },
        get creationMoment(): string {
            return i18nService.choose(
                'Дата отправки из Favorit',
                'Алынған күні',
                'Received date',
            );
        },
    },
    get successImported(): string {
        return i18nService.choose(
            'Импорт из Favorit запущен, версия штатного расписания создана',
            'Favorit жүйесінен импорттау басталды, штат кестесінің нұсқасы жасалды',
            'Import from Favorit has been started, staffing table version created',
        );
    },
    errors: {
        get loadCandidates(): string {
            return i18nService.choose(
                'Не удалось загрузить список организаций для импорта',
                'Импорттауға арналған ұйымдар тізімін жүктеу мүмкін болмады',
                'Failed to load the list of organizations available for import',
            );
        },
        get import(): string {
            return i18nService.choose(
                'Не удалось выполнить импорт из Favorit',
                'Favorit жүйесінен импорттау мүмкін болмады',
                'Failed to import from Favorit',
            );
        },
    },
};


@Component({
    components: {
        Overlay,
    },
})
export default class FavoriteImportModal extends Vue {
    // region Модель, свойства
    @Prop({ type: Boolean, required: false, default: false })
    public readonly value!: boolean;

    /** Код ГУ организации, выбранной на странице - кандидаты фильтруются по нему */
    @Prop({ type: String, required: false, default: null })
    public readonly codeGu!: string | null;
    $bvToast: any;
    // endregion


    // region Lifecycle
    private created() {
        this.$watch('value', (visible: boolean) => {
            if (visible) {
                this.resetState();
                this.loadCandidates();
            }
        });
    }
    // endregion


    // region Утилиты
    private translates = translates;

    private toast(type: 'danger' | 'warning' | 'success', title: string, message: string) {
        this.$bvToast.toast(message, {
            title: title,
            variant: type,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true,
        });
    }

    private formatDate(value: string): string {
        return this.$d(new Date(value), 'short');
    }

    private formatDateTime(value: string): string {
        return this.$d(new Date(value), 'long');
    }
    // endregion


    // region Видимость
    private get internalVisible(): boolean {
        return this.value;
    }

    private set internalVisible(value: boolean) {
        this.$emit(modelChangeEvent, value);
    }

    private resetState() {
        this.year = new Date().getFullYear();
        this.title = '';
        this.selectedCandidate = null;
        this.rows = [];
    }

    private onCancelClick() {
        this.internalVisible = false;
    }
    // endregion


    // region Поля - год, наименование версии
    private year: number = new Date().getFullYear();
    private title: string = '';
    // endregion


    // region Таблица кандидатов
    private loading = false;
    private rows: IRow[] = [];
    private selectedCandidate: FavoriteMetaDataCandidate | null = null;

    private get fields(): Comp.TableFieldDef[] {
        return [
            { key: 'select', label: '' },
            { key: 'data.id', label: translates.columns.id },
            { key: 'data.docNumber', label: translates.columns.docNumber },
            { key: 'data.docDate', label: translates.columns.docDate },
            { key: 'data.creationMoment', label: translates.columns.creationMoment },
        ];
    }

    private loadCandidates() {
        if (this.loading) {
            console.error('Cannot load Favorit candidates - another loading is running');
            return;
        }

        this.rows = [];
        this.selectedCandidate = null;

        if (!this.codeGu) {
            return;
        }

        this.loading = true;
        Ax<Array<FavoriteMetaDataCandidate>>(
            {
                url: '/api/budget/staffing_table/integration/favorite/meta-data',
                params: {
                    'code-gu': this.codeGu,
                },
            },
            (data) => {
                this.rows = data.map((item): IRow => ({
                    id: String(item.id),
                    data: item,
                    _rowVariant: null,
                }));
            },
            (error) => {
                this.toast(
                    'danger',
                    translates.errors.loadCandidates,
                    error.toString(),
                );
            },
            () => {
                this.loading = false;
            },
        );
    }

    private isRowSelected(row: IRow): boolean {
        return (this.selectedCandidate !== null) && (this.selectedCandidate.id === row.data.id);
    }


    private toggleRowSelection(row: IRow) {
        const selectedCandidate = this.selectedCandidate;
        const isSame = (selectedCandidate !== null) && (selectedCandidate.id === row.data.id);
        this.selectedCandidate = isSame ? null : row.data;

        this.rows = this.rows.map((r): IRow => ({
            ...r,
            _rowVariant: ((this.selectedCandidate !== null) && (this.selectedCandidate.id === r.data.id)) ? 'primary' : null,
        }));
    }
    // endregion


    // region Импорт
    private importing = false;

    private get importDisabled(): boolean {
        if (this.loading || this.importing) {
            return true;
        }
        if (this.selectedCandidate === null) {
            return true;
        }
        if (!Number.isFinite(Number(this.year)) || (Number(this.year) <= 0)) {
            return true;
        }
        if (this.title.trim().length === 0) {
            return true;
        }
        return false;
    }

    private onImportClick() {
        if (this.importing) {
            console.error('Cannot import from Favorit - another import is running');
            return;
        }

        const candidate = this.selectedCandidate;
        if (candidate === null) {
            console.error('Cannot import from Favorit - no candidate selected');
            return;
        }

        const orgCode = `GU#${candidate.codeGu}`;

        this.importing = true;
        Ax(
            {
                url: '/api/budget/staffing_table/integration/favorite/import',
                method: 'POST',
                data: {
                    metaDataId: candidate.id,
                    orgCode: orgCode,
                    year: Number(this.year),
                    title: this.title.trim(),
                },
            },
            () => {
                this.toast(
                    'success',
                    '',
                    translates.successImported,
                );
                this.internalVisible = false;
                this.$emit(importedEvent);
            },
            (error) => {
                this.toast(
                    'danger',
                    translates.errors.import,
                    error.toString(),
                );
            },
            () => {
                this.importing = false;
            },
        );
    }
    // endregion
}
